import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../contexts/authContext';
import { registryRecordClient } from '../registryRecordClient';
export const lcatAnchorKeys = {
    all: [
        'registry',
        'lcat-anchor'
    ],
    dossier: (viewer, id)=>[
            ...lcatAnchorKeys.all,
            viewer,
            id,
            'dossier'
        ],
    points: (viewer, id, fy)=>[
            ...lcatAnchorKeys.all,
            viewer,
            id,
            'points',
            ...fy
        ],
    people: (viewer, id)=>[
            ...lcatAnchorKeys.all,
            viewer,
            id,
            'people'
        ]
};
/** Dossier, plotted points (per fiscal-year selection) and people for one anchor. */ export function useLaborCategoryAnchor(anchorId, fiscalYears) {
    const { user } = useAuth();
    const viewer = `${user?.tenant_id ?? ''}:${user?.id ?? ''}`;
    const enabled = !!user?.tenant_id && !!user?.id && !!anchorId;
    const dossier = useQuery({
        queryKey: lcatAnchorKeys.dossier(viewer, anchorId),
        enabled,
        retry: false,
        queryFn: ()=>registryRecordClient.getLaborCategoryAnchorDossier({
                anchorId
            })
    });
    const relatedEnabled = enabled && !!dossier.data;
    const points = useQuery({
        queryKey: lcatAnchorKeys.points(viewer, anchorId, fiscalYears),
        enabled: relatedEnabled,
        retry: false,
        queryFn: ()=>registryRecordClient.listAnchorRatePoints({
                anchorId,
                fiscalYears
            })
    });
    const people = useQuery({
        queryKey: lcatAnchorKeys.people(viewer, anchorId),
        enabled: relatedEnabled,
        retry: false,
        queryFn: ()=>registryRecordClient.listAnchorPeople({
                anchorId
            })
    });
    return {
        dossier,
        points,
        people
    };
}
